module.exports = __webpack_public_path__ + "static/media/PhotoRoom-20230626_084150.dd65b284.png";